import { getCurrentCustomerId, redirectToSignIn } from "app/root/Root";
import {getAuthToken} from "common-ui-components/accounts/framework/AuthTokenHandler"
import {API_URL, buildUrl, PRODUCT_ID} from "common-ui-components/components/utils/Config";
function handleResponse(response)
{
    if (!response.ok) {
        const error = new Error(`HTTP Error ${response.status}`);
        error.status = response.status;
        return response.json().then(body => {
            error.body = body;
            throw error;
        });
    }
    return response.json();
}

function handleError(error, onError)
{
    if (error.status === 401) {
        console.warn("Unauthorized! Redirecting to login...");
        redirectToSignIn();
    }
    console.error(error);
    onError?.(error);
}

function buildHeaders(isMultipart = false)
{
    const token = getAuthToken();

    //this is for the hardcoded token
    // const token ="b8-c8olZQB7k7dg9lUE1518Ax9ig7lunhvqK_ZKbw8w"

    const headers = {};
    if (!isMultipart) {
        headers["Content-Type"] = "application/json";
    }
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    headers["customerId"] = getCurrentCustomerId();
    return headers;
}

/**
 * @deprecated This component is deprecated and will be removed from the next version.
 * Please use `API.js` instead from the common ui components in the util package .
 */
export function get(url, onSuccess, onFailure, onError) {

    const fullUrl = buildUrl(API_URL, url,PRODUCT_ID);

    fetch(fullUrl, {
        method: "GET",
        headers: buildHeaders(),
        credentials: "include", // ensures cookies/session tokens are sent
    })
        .then(handleResponse)
        .then(response => {
            if (response.status?.success === false)
                onFailure?.(response.status, response.body);
            else
                onSuccess?.(response.status, response.body);
        })
        .catch(error => handleError(error, onError));
}

/**
 * @deprecated This component is deprecated and will be removed from the next version.
 * Please use `API.js` instead from the common ui components in the util package .
 */
export function put(url, body, onSuccess, onFailure, onError)
{
    const fullUrl = buildUrl(API_URL, url,PRODUCT_ID);

    fetch(fullUrl, {
        method: "PUT",
        headers: buildHeaders(),
        credentials: "include", //ensures cookies/session tokens are sent
        body: (body != undefined && body != null) ? JSON.stringify(body) : {}
    })
        .then(handleResponse)
        .then(response => {
            if (response.status.success === false)
                onFailure(response.status, response.body)
            else
                onSuccess(response.status, response.body)
        })
        .catch(error => handleError(error,onError));
}

/**
 * @deprecated This component is deprecated and will be removed from the next version.
 * Please use `API.js` instead from the common ui components in the util package .
 */
export function post(url, body, onSuccess, onFailure, onError) 
{
    const fullUrl = buildUrl(API_URL, url,PRODUCT_ID);

    fetch(fullUrl, {
        method: "POST",
        headers: buildHeaders(),
        credentials: "include", //ensures cookies/session tokens are sent
        body: (body != undefined && body != null) ? JSON.stringify(body) : {}
    })
        .then(handleResponse)
        .then(response => {
            if (response.status.success === false)
                onFailure(response.status, response.body)
            else
                onSuccess(response.status, response.body)
        })
        .catch(error => handleError(error,onError));
}

/**
 * @deprecated This component is deprecated and will be removed from the next version.
 * Please use `API.js` instead from the common ui components in the util package .
 */
export function deleteApi(url, body, onSuccess, onFailure, onError) 
{
    const fullUrl = buildUrl(API_URL, url,PRODUCT_ID);

    fetch(fullUrl, {
        method: "DELETE",
        headers: buildHeaders(),
        credentials: "include", //ensures cookies/session tokens are sent
        body: (body != undefined && body != null) ? JSON.stringify(body) : {}
    })
        .then(handleResponse)
        .then(response => {
            if (response?.status === false)
                onFailure(response, response.body)
            else
                onSuccess(response, response.body)
        })
        .catch(error => handleError(error,onError));
}

/**
 * @deprecated This component is deprecated and will be removed from the next version.
 * Please use `API.js` instead from the common ui components in the util package .
 */
export function multipart(url, formdata, onSuccess, onFailure, onError) 
{
    const fullUrl = buildUrl(API_URL, url,PRODUCT_ID);

    fetch(fullUrl, {
        method: "POST",
        headers: buildHeaders(true),
        credentials: "include", //ensures cookies/session tokens are sent
        body: formdata
    })
        .then(handleResponse)
        .then(response => {
            if (response.status.success === false)
                onFailure(response.status, response.body)
            else
                onSuccess(response.status, response.body)
        })
        .catch(error => handleError(error,onError));
}